module.exports = __webpack_public_path__ + "static/media/background-mobile.356b26a2.jpg";